import React from 'react';
import { validateMaxLen, validateNotEmpty } from '@tfecom-thermofisher/react-komodo-design';

import { Message } from 'src/core/components';

import { RNA_OPTIONS } from './constants';
import messages from './messages';

const SENSE_SEQUENCE_REGEX = '^[ACGUacgu]+$';
const NAME_REGEX = '^[a-zA-Z0-9_ .-]+$';

export const RESEARCHER_NAME_MAX = 30;
export const OLIGO_NAME_MAX = 30;

export const getRequiredValidator = (errorMessage) => ({
  validator: validateNotEmpty,
  errorMessage: <Message message={errorMessage} />,
});

export const senseSequenceValidator = ({
  validator: (value) => new RegExp(SENSE_SEQUENCE_REGEX).test(value) ? 'success' : 'error',
  errorMessage: <Message message={messages.sequenceError} />,
});

export const getSequenceFixedLengthValidator = (length = 25) => ({
  validator: (value) => value?.length === length ? 'success' : 'error',
  errorMessage: <Message message={{
    ...messages.seseSequenceFixedLengthError,
    values: { length }
  }}
  />,
});

export const senseSequenceLengthIntervalValidator = (min = 10, max = 50) => ({
  validator: (value) => value?.length >= min && value?.length <= max ? 'success' : 'error',
  errorMessage: <Message message={{
    ...messages.seseSequenceIntervalLengthError,
    values: { min, max }
  }}
  />,
});

export const getSenseValidators = (rnaType) => {
  const validators = [
    getRequiredValidator(messages.senseSequenceRequired),
    senseSequenceValidator
  ];

  if (rnaType === RNA_OPTIONS.SI_RNA) {
    return [
      ...validators,
      senseSequenceLengthIntervalValidator(),
    ];
  }

  return rnaType === RNA_OPTIONS.STEALTH_RNAI ? [
    ...validators,
    getSequenceFixedLengthValidator(),
  ] : validators;
};

export const maxLenValidator = (maxLen, errorMessage = {}) => ({
  validator: (value) => validateMaxLen(value, maxLen),
  errorMessage: <Message message={errorMessage} />,
});

export const nameValidator = (errorMessage = {}) => ({
  validator: (value) => new RegExp(NAME_REGEX).test(value) ? 'success' : 'error',
  errorMessage: <Message message={errorMessage} />,
});

export const startsWithSpaceValidator = (errorMessage = {}) => ({
  validator: (value) => (/^[^-\s]/.test(value) ? 'success' : 'error'),
  errorMessage: <Message message={errorMessage} />,
});
